import React, { FC } from 'react';
import cx from 'classnames';
import useThemeBlock from '@/hooks/useThemeBlock';
import { CardLinkProps } from '@/helpers/CardControls/typings';
import { Link } from '@/helpers/Link/render';
// internal
import { getStyles } from './styles.css';

import block from './block.json';

/**
 * TYPINGS
 */
export type CardKeyfactTextProps = {
	title: string;
	label: string;
	link?: CardLinkProps;
} & ThemeProps;

/**
 * COMPONENT
 */
export const CardKeyfactText: FC<CardKeyfactTextProps> & BlockConfigs = ({
	title,
	label,
	link: { href = null, opensInNewTab = false, ...linkProps } = {},
	theme = {},
}) => {
	const { variant, blockTheme } = useThemeBlock(block.slug, theme);

	const htmlProps = {
		'data-variant': variant,
	};

	const rootClass = cx(
		'supt-card supt-cardKeyfact supt-cardKeyfact--text',
		getStyles(blockTheme),
		href && 'supt-withLink'
	);

	return (
		<div className={rootClass} data-block={block.slug} {...htmlProps}>
			{href ? (
				<Link
					href={href}
					className="supt-cardKeyfact__title supt-cardKeyfact__link"
					{...(opensInNewTab && {
						target: '_blank',
						rel: 'noopener noreferrer',
					})}
					dangerouslySetInnerHTML={{ __html: title }}
					{...linkProps}
				/>
			) : (
				<p
					className="supt-cardKeyfact__title"
					dangerouslySetInnerHTML={{ __html: title }}
				/>
			)}
			<p
				className="supt-cardKeyfact__label"
				dangerouslySetInnerHTML={{ __html: label }}
			/>
		</div>
	);
};

CardKeyfactText.slug = block.slug;
CardKeyfactText.title = block.title;
